import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@fuww/library/src/Avatar';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import Image from '../Image';

const fetchImage = async (url, setImageAvailable) => {
  try {
    const { ok, status } = await fetch(url);

    if (ok) return setImageAvailable(true);
    throw new Error(`status: ${status}`);
  } catch {
    return setImageAvailable(false);
  }
};

const UserAvatar = ({
  user,
  size,
  ...properties
}) => {
  const { name, imageUrls } = user;

  const [avatarAvailable, setAvatarAvailable] = useState();
  useEffect(() => {
    if (imageUrls[0]) {
      fetchImage(imageUrls[0], setAvatarAvailable);
    } else {
      setAvatarAvailable(false);
    }
  }, [imageUrls]);

  return (
    <>
      <Avatar
        name={name}
        image={avatarAvailable && imageUrls && (
        <Image
          placeholder={imageUrls[0]}
          src={imageUrls[1]}
          alt={name}
          sizes={`${size}px`}
          loadStrategy="instant"
          placeholderLoadStrategy="instant"
          srcSet={`${imageUrls[1]
          } ${size}w, ${imageUrls[2]
          } ${size * 2}w, ${imageUrls[3]
          } ${size * 3}w`}
        />
        )}
        size={size}
        {...properties}
      />
      {typeof avatarAvailable !== 'boolean' && <HiddenLoader />}
    </>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.number.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string,
    imageUrls: PropTypes.arrayOf(
      PropTypes.string,
    ),
  }).isRequired,
};

export default UserAvatar;
